// Unpublished Work © 2023-2026 Deere & Company.

import React from 'react';
import {useSelector} from 'react-redux';

export const WalkMeHiddenUserHooks = () => {
    const parentAppName = useSelector((state) => state.configuration.parentAppName);
    const {
        country,
        impersonateUserId,
        isBranch29User,
        loggedInUserId,
        r2CRMUser
    } = useSelector((state) => state.user);

    const inputs = [
        {
            id: 'walk-me-logged-in-user-id-hook',
            value: loggedInUserId
        },
        {
            id: 'walk-me-impersonate-user-id-hook',
            value: impersonateUserId
        },
        {
            id: 'walk-me-parent-app-name-hook',
            value: parentAppName
        },
        {
            id: 'walk-me-user-country-hook',
            value: country
        },
        {
            id: 'walk-me-branch29-user-hook',
            value: String(isBranch29User ?? '')
        },
        {
            id: 'walk-me-r2crmuser-hook',
            value: String(r2CRMUser ?? '')
        }
    ];

    return (
        <>
            {inputs.map(({
                id, value
            }) => (
                <input
                    id={id}
                    key={id}
                    readOnly
                    type={'hidden'}
                    value={value ?? ''}
                />
            ))}
        </>
    );
};
